import React from "react";
import styled from "styled-components";
import { SkeletonBox, SkeletonText } from "./SkeletonBox";

/**
 * ProfilePageSkeleton - Skeleton matching profileContent.jsx layout
 */

const ContentWrapper = styled.div`
  width: 100%;
  height: 100%;
  padding: 32px 48px;
  overflow-y: hidden;
`;

const ProfileCard = styled.div`
  background: #1a1a1a;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  padding: 24px;
  margin: 0 auto;
  width: 100%;
`;

const SectionCard = styled.div`
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
`;

// Simulate UserTable
const UserInfoRow = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;

const UserInfoCell = styled.div`
  padding: 0;
  vertical-align: middle;
`;

const Divider = styled.div`
  width: 1px;
  height: 60px;
  background: rgba(255, 255, 255, 0.1);
  margin: 0 24px;
`;

// Simulate MenuTable
const MenuGrid = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  margin-top: 16px;
`;

const MenuButtonSkeleton = styled.div`
  flex: 1;
  background: #262626;
  border-radius: 20px;
  padding: 24px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100px;
`;

const QRPlaceholder = styled.div`
  width: 256px;
  height: 256px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  margin: 0 auto;
`;

function ProfilePageSkeleton() {
  return (
    <ContentWrapper>
      <ProfileCard>
        {/* User Info Section Skeleton */}
        <SectionCard>
          <UserInfoRow>
            {/* Avatar */}
            <UserInfoCell style={{ width: "90px" }}>
              <SkeletonBox width={75} height={75} circle />
            </UserInfoCell>

            {/* Name & Phone */}
            <UserInfoCell style={{ width: "200px" }}>
              <SkeletonText width={120} size="xl" style={{ marginBottom: 8 }} />
              <SkeletonText width={100} size="md" />
            </UserInfoCell>

            {/* Divider */}
            <UserInfoCell style={{ width: "50px" }}>
              <Divider />
            </UserInfoCell>

            {/* Subscription Info */}
            <UserInfoCell style={{ flex: 1 }}>
              <SkeletonText width={180} size="md" style={{ marginBottom: 8 }} />
              <SkeletonText width={100} size="sm" />
            </UserInfoCell>

            {/* QR Code */}
            <UserInfoCell style={{ width: "280px", textAlign: "center" }}>
              <SkeletonText width={100} size="sm" style={{ margin: "0 auto 12px" }} />
              <SkeletonBox width={240} height={240} style={{ borderRadius: 12 }} />
            </UserInfoCell>
          </UserInfoRow>
        </SectionCard>

        {/* Menu Grid Skeleton */}
        <MenuGrid>
          {[1, 2, 3, 4].map((item) => (
            <MenuButtonSkeleton key={item}>
              <SkeletonBox width={32} height={32} style={{ marginBottom: 12 }} />
              <SkeletonText width={80} size="md" />
            </MenuButtonSkeleton>
          ))}
        </MenuGrid>

        {/* Possible Subscription Button Skeleton */}
        {/* <SkeletonBox width="100%" height={60} style={{ marginTop: 16, borderRadius: 20 }} /> */}
      </ProfileCard>
    </ContentWrapper>
  );
}

export default ProfilePageSkeleton;
